// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".coupon-dia .van-popup {\n  background-color: #f8f8f8;\n}\n.coupon-dia .van-tabs__nav {\n  background-color: #f8f8f8 !important;\n}", ""]);
// Exports
module.exports = exports;
